import IDraggable from '@/Domain/interfaces/IDraggable';
import { IInscriptionCandidateReference } from '@/Domain/interfaces/Process/IProcessReference';

export default class ReferencesHandler implements IDraggable {
    dragging: boolean = false;
    isDragableDisabled: boolean = false;
    readonly dragClass: string = 'draggable';

    onMove(evt) {
        return evt.dragged.classList.contains(this.dragClass)
            && (!evt.related || evt.related.classList.contains(this.dragClass));
    }

    onDragEnd(evt) {
        if (!evt.clone.classList.contains(this.dragClass)) {
            return;
        }
    }

    onSelectedReferenceChange(referenceToUpdate: IInscriptionCandidateReference, referencesSelectedList: IInscriptionCandidateReference[]) {
        referenceToUpdate.order = referenceToUpdate.selected ? referencesSelectedList.length : null as any;
        if (this.hasInvalidOrderReferenceToUpdate(referenceToUpdate)) {
            this.orderAllList(referencesSelectedList);
            return;
        }
    }

    onReferenceOrderChange(referenceWithOrderChanged: IInscriptionCandidateReference, referencesSelectedList: IInscriptionCandidateReference[]) {
        const newIndex = referenceWithOrderChanged.order - 1;

        if (newIndex < 0 || isNaN(newIndex) || newIndex >= referencesSelectedList.length) {
            return;
        }

        const currentIndex = referencesSelectedList.findIndex(ref => ref.referenceId === referenceWithOrderChanged.referenceId);
        if (currentIndex === -1) { return; }

        referencesSelectedList.splice(currentIndex, 1);

        referencesSelectedList.splice(newIndex, 0, referenceWithOrderChanged);

        this.orderAllList(referencesSelectedList);
    }

    updateOrderOnList(referenceWithOrderChanged: IInscriptionCandidateReference, referencesSelectedList: IInscriptionCandidateReference[], newIndex: number, currentIndex: number) {
        if (this.hasInvalidOrderReferenceToUpdate(referenceWithOrderChanged)) {
            this.orderAllList(referencesSelectedList);
            return;
        }
        
        referencesSelectedList.splice(currentIndex, 1);

        referencesSelectedList.splice(newIndex, 0, referenceWithOrderChanged);

        referencesSelectedList.forEach((ref, index) => {
            ref.order = index + 1;
        });
    }

    disableDragAndrop() {
        this.isDragableDisabled = true;
    }
    
    enableDragAndrop() {
        this.isDragableDisabled = false;
    }

    matchSelectedReferencesWithStructureReferences(inscriptionStructureReferences, inscriptionReferences) {
        if (inscriptionReferences.length > 0) {
            inscriptionStructureReferences.forEach(ref => {
                const reference = inscriptionReferences.find(item => item.referenceId === ref.referenceId);
                if (reference) {
                    ref.selected = true;
                    ref.order = reference.order;
                }
            });
        }
        return inscriptionStructureReferences;
    }

    resetReferences(inscriptionReferences) {
        inscriptionReferences.forEach(ref => {
            ref.selected = false;
            ref.order = null as any;
        });
        return inscriptionReferences;
    }

    private orderAllList(referencesSelectedList: IInscriptionCandidateReference[]) {
        referencesSelectedList.forEach((reference, index) => {
            if (reference.selected) {
                reference.order = index + 1;
            }
        });
    }

    private hasInvalidOrderReferenceToUpdate(referenceWithOrderChanged: IInscriptionCandidateReference) {
        return referenceWithOrderChanged.order === null || isNaN(referenceWithOrderChanged.order) || (referenceWithOrderChanged.order as any) === '';
    }
}
